import type { MachineOperationsDetailReqType } from '@/models/types/machine.types'
import { type ApiResponse, ApiFactory } from '@/utils/api'
import { ClawMachineEnum } from '@/constants/enums/api/clawMachine.enums'
import { CoinMachineEnum } from '@/constants/enums/api/coinMachine.enums'

export class DashboardAccountInquiryServices extends ApiFactory {
  constructor() {
    super('')
  }

  /** 取得選物機帳務清單 */
  getClawOperationsDetail = async (
    param: MachineOperationsDetailReqType,
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<MachineOperationsDetailReqType, ApiResponse>(
      ClawMachineEnum.operationsDetail,
      param,
      {
        signal: abortSignal
      }
    )
  }

  /** 新系統：取得選物機帳務清單 */
  getClawOperationsDetailV2 = async (
    param: MachineOperationsDetailReqType,
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<MachineOperationsDetailReqType, ApiResponse>(
      ClawMachineEnum.operationsDetailV2,
      param,
      {
        signal: abortSignal
      }
    )
  }

  /** 取得選物機商品紀錄清單 */
  getClawGoodsRecord = async (
    param: { pcbId: string },
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<{ pcbId: string }, ApiResponse>(ClawMachineEnum.goodsRecord, param, {
      signal: abortSignal
    })
  }

  /** 新系統：取得選物機商品紀錄清單 */
  getClawGoodsRecordV2 = async (
    param: { pcbId: string },
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<{ pcbId: string }, ApiResponse>(ClawMachineEnum.goodsRecordV2, param, {
      signal: abortSignal
    })
  }

  /** 取得選物機事件紀錄清單 */
  getClawEventRecord = async (param: MachineOperationsDetailReqType, abortSignal?: AbortSignal) => {
    return await this.get<MachineOperationsDetailReqType, ApiResponse>(
      ClawMachineEnum.eventRecord,
      param,
      {
        signal: abortSignal
      }
    )
  }

  /** 新系統：取得選物機事件紀錄清單 */
  getClawEventRecordV2 = async (
    param: MachineOperationsDetailReqType,
    abortSignal?: AbortSignal
  ) => {
    return await this.get<MachineOperationsDetailReqType, ApiResponse>(
      ClawMachineEnum.eventRecordV2,
      param,
      {
        signal: abortSignal
      }
    )
  }

  /** 取得兌幣機帳務清單 */
  getCoinOperationsDetail = async (
    param: MachineOperationsDetailReqType,
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<MachineOperationsDetailReqType, ApiResponse>(
      CoinMachineEnum.operationsDetail,
      param,
      {
        signal: abortSignal
      }
    )
  }

  /** 新系統：取得兌幣機帳務清單 */
  getCoinOperationsDetailV2 = async (
    param: MachineOperationsDetailReqType,
    abortSignal?: AbortSignal
  ): Promise<ApiResponse> => {
    return await this.get<MachineOperationsDetailReqType, ApiResponse>(
      CoinMachineEnum.operationsDetailV2,
      param,
      {
        signal: abortSignal
      }
    )
  }

  /** 取得兌幣機事件紀錄清單 */
  getCoinEventRecord = async (param: MachineOperationsDetailReqType, abortSignal?: AbortSignal) => {
    return await this.get<MachineOperationsDetailReqType, ApiResponse>(
      CoinMachineEnum.eventRecord,
      param,
      {
        signal: abortSignal
      }
    )
  }

  /** 新系統：取得兌幣機事件紀錄清單 */
  getCoinEventRecordV2 = async (
    param: MachineOperationsDetailReqType,
    abortSignal?: AbortSignal
  ) => {
    return await this.get<MachineOperationsDetailReqType, ApiResponse>(
      CoinMachineEnum.eventRecordV2,
      param,
      {
        signal: abortSignal
      }
    )
  }
}
